import React from 'react';
import ComingSoonPage from '../../components/common/ComingSoonPage';

export const LibraryPage: React.FC = () => {
  return <ComingSoonPage title="Library" description="This feature is under development." />;
};

export default LibraryPage;

